/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Cloud provider.
*/
export enum Provider {
  Aws = 'AWS',
  Azure = 'AZURE',
  Gcp = 'GCP',
  MongoAtlas = 'MONGO_ATLAS',
  ProviderUnspecified = 'PROVIDER_UNSPECIFIED'
}
